var map = {
	"./arrow-left-white.png": "0dee",
	"./arrow-left.png": "2584",
	"./arrow-right-white.png": "cd8a",
	"./arrow-right.png": "9e6b",
	"./card/back.png": "a5fb",
	"./card/edit.png": "9ff0",
	"./card/trash.png": "758a",
	"./card/visa.png": "bc84",
	"./checkout/back.png": "97c5",
	"./checkout/background-ball.png": "196d",
	"./checkout/cart-empty.png": "49f6",
	"./checkout/edit.png": "34b6",
	"./checkout/empty-cart.png": "0acd",
	"./checkout/info-green.png": "3863",
	"./checkout/info.png": "96bb",
	"./checkout/inspiring.png": "0328",
	"./checkout/line.png": "2104",
	"./checkout/trash.png": "3635",
	"./common/amex.png": "d261",
	"./common/arrow-right-gray.png": "635f",
	"./common/arrow-right-green.png": "b36b",
	"./common/arrow-right.png": "f711",
	"./common/bgr-no-color.png": "63c4",
	"./common/card-master.png": "4490",
	"./common/card-visa.png": "171f",
	"./common/clock.png": "953d",
	"./common/close.png": "8eeb",
	"./common/compeleted.png": "860e",
	"./common/cross.png": "d077",
	"./common/datepicker.png": "c66a",
	"./common/down.png": "11de",
	"./common/dropdown-green.png": "2fdb",
	"./common/edit.png": "a7fb",
	"./common/failed.png": "4888",
	"./common/failure.png": "a80c",
	"./common/filter.png": "e06e",
	"./common/icon-email.png": "9deb",
	"./common/icon-google.png": "dfbc",
	"./common/icon-right.png": "6233",
	"./common/icon-sms.png": "349e",
	"./common/info.png": "9638",
	"./common/live.png": "5be1",
	"./common/master.png": "de13",
	"./common/nbo-master.png": "5eab",
	"./common/nbo-visa.png": "9d88",
	"./common/pattern.png": "42e3",
	"./common/processing.png": "cae4",
	"./common/random-numbers.png": "3bc1",
	"./common/stop.png": "7913",
	"./common/success.png": "2143",
	"./common/trash.png": "359b",
	"./common/up.png": "f9904",
	"./common/vector-down.png": "8a82",
	"./common/visa.png": "f02c",
	"./download.png": "96fc",
	"./flags/'.svg": "1af9",
	"./flags/Afghanistan.png": "9239",
	"./flags/Flag_of_Albania.svg": "2e87",
	"./flags/Flag_of_Algeria.svg": "f300",
	"./flags/Flag_of_Andorra.svg": "c645",
	"./flags/Flag_of_Angola.svg": "9174",
	"./flags/Flag_of_Anguilla.svg": "9d67",
	"./flags/Flag_of_Antigua_and_Barbuda.svg": "5fa3",
	"./flags/Flag_of_Argentina.svg": "6bf7",
	"./flags/Flag_of_Armenia.svg": "96de",
	"./flags/Flag_of_Aruba.svg": "24f0",
	"./flags/Flag_of_Australia.svg": "1e00",
	"./flags/Flag_of_Austria.svg": "3331",
	"./flags/Flag_of_Azerbaijan.svg": "60e0",
	"./flags/Flag_of_Bahrain (1).svg": "393b",
	"./flags/Flag_of_Bahrain.svg": "4bfc",
	"./flags/Flag_of_Bangladesh (1).svg": "f62b",
	"./flags/Flag_of_Bangladesh.svg": "47db",
	"./flags/Flag_of_Barbados (1).svg": "5b56",
	"./flags/Flag_of_Barbados.svg": "febd",
	"./flags/Flag_of_Belarus (1).svg": "e72a",
	"./flags/Flag_of_Belarus.svg": "0ef3",
	"./flags/Flag_of_Belgium (1).svg": "92d5",
	"./flags/Flag_of_Belgium.svg": "fea5",
	"./flags/Flag_of_Belize (1).svg": "0773",
	"./flags/Flag_of_Belize.svg": "6efb",
	"./flags/Flag_of_Benin (1).svg": "fdf0",
	"./flags/Flag_of_Benin.svg": "e016",
	"./flags/Flag_of_Bermuda (1).svg": "24da",
	"./flags/Flag_of_Bermuda.svg": "0d6c",
	"./flags/Flag_of_Bhutan (1).svg": "2ef4",
	"./flags/Flag_of_Bhutan.svg": "5f98",
	"./flags/Flag_of_Bosnia_and_Herzegovina.svg": "6996",
	"./flags/Flag_of_Botswana.svg": "e634",
	"./flags/Flag_of_Brazil.svg": "3416",
	"./flags/Flag_of_Brunei.svg": "b548",
	"./flags/Flag_of_Bulgaria.svg": "4b26",
	"./flags/Flag_of_Burkina_Faso.svg": "1fa0",
	"./flags/Flag_of_Burundi.svg": "0d0a",
	"./flags/Flag_of_Cambodia.svg": "3bfe",
	"./flags/Flag_of_Cameroon.svg": "2982",
	"./flags/Flag_of_Canada.svg": "66a3",
	"./flags/Flag_of_Cape_Verde.svg": "949c",
	"./flags/Flag_of_Chad.svg": "67c0",
	"./flags/Flag_of_Chile.svg": "64da",
	"./flags/Flag_of_Christmas_Island.svg": "f0d9",
	"./flags/Flag_of_Colombia.svg": "6a28",
	"./flags/Flag_of_Croatia.svg": "bb93",
	"./flags/Flag_of_Cuba.svg": "f021",
	"./flags/Flag_of_Cyprus.svg": "4efe",
	"./flags/Flag_of_Denmark.svg": "2c4e",
	"./flags/Flag_of_Djibouti.svg": "bf26",
	"./flags/Flag_of_Dominica.svg": "4618",
	"./flags/Flag_of_East_Timor.svg": "bbd4",
	"./flags/Flag_of_Ecuador.svg": "6d3c",
	"./flags/Flag_of_Egypt.svg": "da3d",
	"./flags/Flag_of_El_Salvador.svg": "962c",
	"./flags/Flag_of_Equatorial_Guinea.svg": "b302",
	"./flags/Flag_of_Eritrea.svg": "92e7",
	"./flags/Flag_of_Estonia.svg": "e666",
	"./flags/Flag_of_Ethiopia.svg": "a90d",
	"./flags/Flag_of_Fiji.svg": "348c",
	"./flags/Flag_of_Finland.svg": "e901",
	"./flags/Flag_of_France (1).svg": "eb8e",
	"./flags/Flag_of_France (2).svg": "fd0b",
	"./flags/Flag_of_France.svg": "7e29",
	"./flags/Flag_of_French_Guiana.svg": "2178",
	"./flags/Flag_of_French_Polynesia.svg": "497f",
	"./flags/Flag_of_Gabon.svg": "6c46",
	"./flags/Flag_of_Georgia.svg": "467b",
	"./flags/Flag_of_Germany.svg": "f2bd",
	"./flags/Flag_of_Gibraltar.svg": "0325",
	"./flags/Flag_of_Greece.svg": "a777",
	"./flags/Flag_of_Greenland.svg": "87e2",
	"./flags/Flag_of_Grenada.svg": "2619",
	"./flags/Flag_of_Guam.svg": "c1c2",
	"./flags/Flag_of_Guatemala.svg": "f637",
	"./flags/Flag_of_Guernsey.svg": "3250",
	"./flags/Flag_of_Guinea-Bissau.svg": "4a3b",
	"./flags/Flag_of_Guinea.svg": "9dba",
	"./flags/Flag_of_Guyana.svg": "b87b",
	"./flags/Flag_of_Haiti.svg": "3979",
	"./flags/Flag_of_Hong_Kong.svg": "bc25",
	"./flags/Flag_of_Hungary.svg": "e821",
	"./flags/Flag_of_Iceland.svg": "9f56",
	"./flags/Flag_of_India.svg": "4904",
	"./flags/Flag_of_Indonesia.svg": "5474",
	"./flags/Flag_of_Iran.svg": "8089",
	"./flags/Flag_of_Iraq.svg": "08b7",
	"./flags/Flag_of_Ireland.svg": "2726",
	"./flags/Flag_of_Israel.svg": "276a",
	"./flags/Flag_of_Italy.svg": "75ed",
	"./flags/Flag_of_Jamaica.svg": "ec55",
	"./flags/Flag_of_Japan.svg": "6f3a",
	"./flags/Flag_of_Jersey.svg": "c56d",
	"./flags/Flag_of_Jordan.svg": "f797",
	"./flags/Flag_of_Kazakhstan.svg": "7fa0",
	"./flags/Flag_of_Kenya.svg": "a8e1",
	"./flags/Flag_of_Kiribati.svg": "09b1",
	"./flags/Flag_of_Kuwait.svg": "e4cd",
	"./flags/Flag_of_Kyrgyzstan.svg": "ceba",
	"./flags/Flag_of_Laos.svg": "6453",
	"./flags/Flag_of_Latvia.svg": "91d1",
	"./flags/Flag_of_Lebanon.svg": "1f36",
	"./flags/Flag_of_Lesotho.svg": "863d",
	"./flags/Flag_of_Liberia.svg": "c1ea",
	"./flags/Flag_of_Liechtenstein.svg": "80f6",
	"./flags/Flag_of_Luxembourg.svg": "12ad",
	"./flags/Flag_of_Macau.svg": "3598",
	"./flags/Flag_of_Madagascar.svg": "505c",
	"./flags/Flag_of_Malawi.svg": "3375",
	"./flags/Flag_of_Malaysia.svg": "b8ad",
	"./flags/Flag_of_Maldives.svg": "2abb",
	"./flags/Flag_of_Mali.svg": "4a49",
	"./flags/Flag_of_Malta.svg": "665d",
	"./flags/Flag_of_Mauritania.svg": "7bb5",
	"./flags/Flag_of_Mauritius.svg": "e1c8",
	"./flags/Flag_of_Mexico.svg": "cdc0",
	"./flags/Flag_of_Monaco.svg": "accc",
	"./flags/Flag_of_Mongolia.svg": "2eec",
	"./flags/Flag_of_Montenegro.svg": "25a9",
	"./flags/Flag_of_Montserrat.svg": "1a80",
	"./flags/Flag_of_Morocco.svg": "6c96",
	"./flags/Flag_of_Mozambique.svg": "3781",
	"./flags/Flag_of_Myanmar.svg": "04c7",
	"./flags/Flag_of_Namibia.svg": "9dce",
	"./flags/Flag_of_Nauru.svg": "5b05",
	"./flags/Flag_of_Nepal.svg": "9fbe",
	"./flags/Flag_of_New_Zealand.svg": "79ff",
	"./flags/Flag_of_Nicaragua.svg": "f606",
	"./flags/Flag_of_Niger.svg": "5deb",
	"./flags/Flag_of_Nigeria.svg": "4e61",
	"./flags/Flag_of_Niue.svg": "751a",
	"./flags/Flag_of_Norfolk_Island.svg": "41ee",
	"./flags/Flag_of_Norway (1).svg": "1b8b",
	"./flags/Flag_of_Norway.svg": "70f6",
	"./flags/Flag_of_Oman.svg": "6a20",
	"./flags/Flag_of_Pakistan.svg": "1389",
	"./flags/Flag_of_Palau.svg": "87a8",
	"./flags/Flag_of_Panama.svg": "86df",
	"./flags/Flag_of_Papua_New_Guinea.svg": "6a44",
	"./flags/Flag_of_Paraguay.svg": "bec8",
	"./flags/Flag_of_Peru.svg": "2c7b",
	"./flags/Flag_of_Poland.svg": "3bdc",
	"./flags/Flag_of_Portugal.svg": "bf95",
	"./flags/Flag_of_Puerto_Rico.svg": "c078",
	"./flags/Flag_of_Qatar.svg": "310d",
	"./flags/Flag_of_Romania.svg": "b0dfd",
	"./flags/Flag_of_Rwanda.svg": "3243",
	"./flags/Flag_of_Saint-Pierre_and_Miquelon.svg": "4366",
	"./flags/Flag_of_Saint_Kitts_and_Nevis.svg": "5715",
	"./flags/Flag_of_Saint_Lucia.svg": "ab22",
	"./flags/Flag_of_Saint_Vincent_and_the_Grenadines.svg": "f4d7",
	"./flags/Flag_of_Samoa.svg": "89a4",
	"./flags/Flag_of_San_Marino.svg": "ea1f",
	"./flags/Flag_of_Sao_Tome_and_Principe.svg": "5c20",
	"./flags/Flag_of_Saudi_Arabia.svg": "0464",
	"./flags/Flag_of_Senegal.svg": "4e9a",
	"./flags/Flag_of_Serbia.svg": "0d4a",
	"./flags/Flag_of_Seychelles.svg": "e730",
	"./flags/Flag_of_Sierra_Leone.svg": "e857",
	"./flags/Flag_of_Singapore.svg": "0397",
	"./flags/Flag_of_Slovakia.svg": "5088",
	"./flags/Flag_of_Slovenia.svg": "a844",
	"./flags/Flag_of_Somalia.svg": "267c",
	"./flags/Flag_of_South_Africa.svg": "c9e3",
	"./flags/Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg": "6764",
	"./flags/Flag_of_Spain.svg": "cec4",
	"./flags/Flag_of_Sri_Lanka.svg": "eba4",
	"./flags/Flag_of_Sudan.svg": "f5e3",
	"./flags/Flag_of_Suriname.svg": "b985",
	"./flags/Flag_of_Swaziland_1894.svg": "55f3",
	"./flags/Flag_of_Sweden.svg": "02eb",
	"./flags/Flag_of_Switzerland.svg": "fafe",
	"./flags/Flag_of_Syria.svg": "3d93",
	"./flags/Flag_of_Tajikistan.svg": "ce2c",
	"./flags/Flag_of_Thailand.svg": "9a3f",
	"./flags/Flag_of_The_Gambia.svg": "74b0",
	"./flags/Flag_of_Togo.svg": "1153",
	"./flags/Flag_of_Tokelau.svg": "7c1e",
	"./flags/Flag_of_Tonga.svg": "4ccb",
	"./flags/Flag_of_Trinidad_and_Tobago.svg": "fd70",
	"./flags/Flag_of_Tunisia.svg": "dd8e",
	"./flags/Flag_of_Turkey.svg": "2570",
	"./flags/Flag_of_Turkmenistan.svg": "676c",
	"./flags/Flag_of_Tuvalu.svg": "054d",
	"./flags/Flag_of_Uganda.svg": "132c",
	"./flags/Flag_of_Ukraine.svg": "a25e",
	"./flags/Flag_of_Uruguay.svg": "0b8c",
	"./flags/Flag_of_Uzbekistan.svg": "34b7",
	"./flags/Flag_of_Vanuatu.svg": "47db4",
	"./flags/Flag_of_Vietnam.svg": "2792",
	"./flags/Flag_of_Wallis_and_Futuna.svg": "8996",
	"./flags/Flag_of_Yemen.svg": "f8a8",
	"./flags/Flag_of_Zambia.svg": "9291",
	"./flags/Flag_of_Zimbabwe.svg": "ffd1",
	"./flags/Flag_of_the_Bahamas.svg": "8a66",
	"./flags/Flag_of_the_Cayman_Islands.svg": "6b3e",
	"./flags/Flag_of_the_Central_African_Republic.svg": "af40",
	"./flags/Flag_of_the_Cocos_(Keeling)_Islands.svg": "d4b4",
	"./flags/Flag_of_the_Comoros.svg": "a195",
	"./flags/Flag_of_the_Cook_Islands.svg": "ea50",
	"./flags/Flag_of_the_Czech_Republic.svg": "eeea",
	"./flags/Flag_of_the_Dominican_Republic.svg": "4c7f",
	"./flags/Flag_of_the_Falkland_Islands.svg": "5423",
	"./flags/Flag_of_the_Faroe_Islands.svg": "7d13",
	"./flags/Flag_of_the_Isle_of_Man.svg": "1901",
	"./flags/Flag_of_the_Marshall_Islands.svg": "3269",
	"./flags/Flag_of_the_Netherlands.svg": "1ae2",
	"./flags/Flag_of_the_Northern_Mariana_Islands.svg": "6113",
	"./flags/Flag_of_the_People's_Republic_of_China.svg": "3ce8",
	"./flags/Flag_of_the_Philippines.svg": "03a6",
	"./flags/Flag_of_the_Pitcairn_Islands.svg": "dd4d",
	"./flags/Flag_of_the_Republic_of_China.svg": "000f",
	"./flags/Flag_of_the_Republic_of_the_Congo.svg": "c39c",
	"./flags/Flag_of_the_Solomon_Islands.svg": "9f71",
	"./flags/Flag_of_the_United_Arab_Emirates.svg": "a641",
	"./flags/Flag_of_the_United_Kingdom.svg": "b768",
	"./flags/Flag_of_the_United_States (1).svg": "0dd8",
	"./flags/Flag_of_the_United_States.svg": "a956",
	"./flags/Flag_of_the_Vatican_City.svg": "21f6",
	"./flags/Flags_of_New_Caledonia.svg": "55d5",
	"./flags/Naval_Ensign_of_Honduras.svg": "d1d7",
	"./flags/Proposed_flag_of_Antarctica.svg": "2fb0",
	"./flags/Unofficial_flag_of_Guadeloupe.svg": "7bde",
	"./footer/Icon_Facebook.svg": "6bba",
	"./footer/Icon_Instagram.svg": "0a6e",
	"./footer/Icon_Tiktok.svg": "6752",
	"./footer/Icon_Twitter.svg": "ae7d",
	"./footer/Icon_Youtube.svg": "dedb",
	"./footer/facebook.png": "111f",
	"./footer/facebook.svg": "6c61",
	"./footer/instagram.png": "435e",
	"./footer/instagram.svg": "fa1b",
	"./footer/snapchat.png": "8603",
	"./footer/tiktok.png": "2285",
	"./footer/tiktok.svg": "3de8",
	"./footer/twitter.png": "a50f",
	"./footer/youtube.png": "6de5",
	"./footer/youtube.svg": "57ba",
	"./header/OM-logo.jpg": "b416",
	"./header/OMillionaire_logo_Final.svg": "3ec0",
	"./header/account/avatar.png": "7dbe",
	"./header/account/card-active.png": "61e7",
	"./header/account/card.png": "7c2d",
	"./header/account/image.png": "8c62",
	"./header/account/my-numbers-active.png": "e31d",
	"./header/account/my-numbers.png": "f6a9",
	"./header/account/my-transactions-active.png": "b96c",
	"./header/account/my-transactions.png": "0929",
	"./header/account/notification-active.png": "ea83",
	"./header/account/notification.png": "9da9",
	"./header/account/personal-active.png": "41d9",
	"./header/account/personal.png": "5718",
	"./header/account/recurring-active.png": "2da2",
	"./header/account/recurring.png": "d331",
	"./header/account/wallet-active.png": "b0c1",
	"./header/account/wallet.png": "7999",
	"./header/background-image.png": "d34e",
	"./header/background-menus.png": "e5de",
	"./header/bell.png": "2e1a",
	"./header/call.png": "bb3c",
	"./header/close.png": "a390",
	"./header/dropdown-icon.png": "e4d0",
	"./header/dropdown-white.png": "4140",
	"./header/favicon.ico": "1bff",
	"./header/line-desktop.png": "e44a",
	"./header/logo-menu.png": "47f8",
	"./header/logo.png": "3ab3",
	"./header/logo_new.png": "331b",
	"./header/shopping-cart.png": "acef",
	"./header/social/Facebook.png": "a945",
	"./header/social/instagram.png": "07c7",
	"./header/social/snapchat.png": "0448",
	"./header/social/tiktok.png": "8539",
	"./header/social/twitter.png": "c646",
	"./header/social/youtube.png": "b14a",
	"./heart.png": "a842",
	"./home/arrow-right.png": "64e3",
	"./home/bacground-home.png": "3a3c",
	"./home/bf-tree.png": "99e9",
	"./home/bg-bottom-tree.png": "0dd0",
	"./home/bg-bottom.png": "6ac3",
	"./home/bg-center.png": "4567",
	"./home/bg-home-desktop.png": "a25f",
	"./home/bg-home.png": "1427",
	"./home/bgr-home-art.jpg": "689f",
	"./home/bgr-home-mobile.png": "5eed",
	"./home/bgr-home.png": "87fd",
	"./home/live.png": "8a11",
	"./icon-date.png": "62ac",
	"./icon-drop-down.png": "21d7",
	"./info.png": "7c12",
	"./inspiring/bg-mobile.png": "a008",
	"./inspiring/bg.png": "1706",
	"./inspiring/download.png": "2487",
	"./inspiring/image.png": "fa83",
	"./landing-page/TV.jpg": "44a3",
	"./landing-page/blue-en-mobile.jpg": "3576",
	"./landing-page/blue-en.jpg": "e0c5",
	"./landing-page/certificate-en-mobile.jpg": "f924",
	"./landing-page/certificate-en.jpg": "9446",
	"./landing-page/guaranteed-mobile.jpg": "fb70",
	"./landing-page/icon-oasis-part-en.png": "55c8",
	"./landing-page/icon-yt.png": "9490",
	"./landing-page/left-arrow-line-symbol.png": "bbe2",
	"./landing-page/park-ar.jpg": "001f",
	"./landing-page/park-en-mobile.jpg": "6d9a",
	"./landing-page/park-en.jpg": "7b31",
	"./landing-page/plant-ar.jpg": "27c6",
	"./landing-page/plant-en.jpg": "1e41",
	"./landing-page/plant-mobile.jpg": "7e299",
	"./landing-page/right-arrow-angle.png": "76b2",
	"./landing-page/tv-mobile.jpg": "0207",
	"./line-heart.png": "57bd",
	"./line-tickets.png": "c0da",
	"./login/background-otp.png": "09da",
	"./menu/sidebar.png": "4dca",
	"./navigation/dollar.png": "75a4",
	"./navigation/hashtag.png": "c752",
	"./navigation/manage.png": "62d9",
	"./navigation/my-transactions.png": "1f57",
	"./navigation/notifi.png": "54ba",
	"./navigation/personal.png": "a37a",
	"./navigation/recurring.png": "4e6b",
	"./notify/background-notify.png": "8d47",
	"./notify/earth.png": "d0e1",
	"./personal-detail/avatar.png": "2a03",
	"./personal-detail/camera.png": "7bbe",
	"./personal-detail/datepicker.png": "00e8",
	"./personal-detail/dropdown-black.png": "0190",
	"./personal-detail/dropdown-green.png": "5f93",
	"./personal-detail/edit-avatar.png": "f95b",
	"./personal-detail/icon-right.png": "98ab",
	"./personal-detail/image.png": "3aa0",
	"./personal-detail/line-head.png": "94d7",
	"./personal-detail/line.png": "4b21",
	"./quickpick.png": "678c",
	"./register/background-mobile.png": "ed23",
	"./register/background-register.png": "5881",
	"./register/background.png": "8307",
	"./register/bg-desktop.png": "0aad",
	"./select-quantity/minus.png": "45e5",
	"./select-quantity/plus.png": "1025",
	"./shuffle-random.png": "7270",
	"./shuffle.png": "6eb6",
	"./static-pages/bg-about-bottom.png": "d67c",
	"./static-pages/bg-green-1.png": "b9ef",
	"./static-pages/bg-green-bottom.png": "a1a2",
	"./static-pages/bg-green.png": "f467",
	"./static-pages/bg.jpg": "beb6",
	"./static-pages/bg.png": "5ac0",
	"./static-pages/calendar.png": "24c4",
	"./static-pages/contact-us/email.png": "68eb",
	"./static-pages/contact-us/facebook.png": "5a94",
	"./static-pages/contact-us/instagram.png": "a0f4",
	"./static-pages/contact-us/map-icon.png": "3954",
	"./static-pages/contact-us/phone-icon.png": "9430",
	"./static-pages/contact-us/tiktok.png": "0c61",
	"./static-pages/contact-us/twitter.png": "97d9",
	"./static-pages/contact-us/whatsapp.png": "0a61",
	"./static-pages/contact-us/youtube-icon.png": "c1ac",
	"./static-pages/draws/banner-past-draws.png": "3740",
	"./static-pages/draws/calendar.png": "b783",
	"./static-pages/draws/close.png": "bca0",
	"./static-pages/draws/icon-next-white.png": "4a68",
	"./static-pages/draws/icon-next.png": "0cac",
	"./static-pages/draws/line-mobile.png": "129d",
	"./static-pages/draws/scroll-bar-1.png": "e2da",
	"./static-pages/draws/scroll-bar-2.png": "4e05",
	"./static-pages/dropdown-how-to.png": "3134",
	"./static-pages/facebook.png": "9179",
	"./static-pages/g1.png": "c79d",
	"./static-pages/g2.png": "7b8e",
	"./static-pages/g3.png": "08f2",
	"./static-pages/g4.png": "4703",
	"./static-pages/g5.png": "8081",
	"./static-pages/g6.png": "68878",
	"./static-pages/green-1-mb.png": "73cc",
	"./static-pages/green-2-mb.png": "f2a9",
	"./static-pages/green-3-mb.png": "e894",
	"./static-pages/green-4-mb.png": "5cc4",
	"./static-pages/green-5-mb.png": "a80b",
	"./static-pages/green-6-mb.png": "3e16",
	"./static-pages/green/1_AR-mb.png": "d047",
	"./static-pages/green/1_AR.png": "3ae6",
	"./static-pages/green/2_AR-mb.png": "8d9e",
	"./static-pages/green/2_AR.png": "d235",
	"./static-pages/green/3_AR-mb.png": "7575",
	"./static-pages/green/3_AR.png": "4e5d",
	"./static-pages/green/4_AR-mb.png": "9df2",
	"./static-pages/green/4_AR.png": "53dd",
	"./static-pages/green/5_AR-mb.png": "6de0",
	"./static-pages/green/5_AR.png": "179b",
	"./static-pages/green/background-mobile.png": "faeb",
	"./static-pages/green/banner-1.jpg": "301c",
	"./static-pages/green/banner-1_AR-mobile.png": "a688",
	"./static-pages/green/banner-1_AR.png": "c9b1",
	"./static-pages/green/banner-Image-text-bg.png": "2db4",
	"./static-pages/green/banner-desktop.png": "b8e1",
	"./static-pages/green/banner.png": "3953",
	"./static-pages/green/content-section.jpg": "0ce8",
	"./static-pages/green/intro-oasis-text.png": "edc0",
	"./static-pages/green/item-middle.jpg": "04e6",
	"./static-pages/green/mid-content.svg": "2c69",
	"./static-pages/green/mid-section-mobile.jpg": "ae72",
	"./static-pages/green/middle-background.jpg": "ec8d5",
	"./static-pages/green/middle-contents/banner-desktop.png": "d312",
	"./static-pages/green/middle-contents/bg-circle.png": "c474",
	"./static-pages/green/middle-contents/bg.png": "8ad8",
	"./static-pages/green/middle-contents/item-1.png": "b1bf",
	"./static-pages/green/middle-contents/item-2.png": "776a",
	"./static-pages/green/one-life-mobile.png": "250b",
	"./static-pages/green/one-life.png": "576e",
	"./static-pages/green/slide-images-01.jpg": "a491",
	"./static-pages/green/slide-images-02.jpg": "7786",
	"./static-pages/green/slide-images-03.jpg": "74ee",
	"./static-pages/green/slide-images-04.jpg": "997a",
	"./static-pages/green/slide-images.jpg": "b3e8",
	"./static-pages/green/slides-mobile.png": "e318",
	"./static-pages/icon-drop-down.png": "6617",
	"./static-pages/icon-join-us.png": "ea86",
	"./static-pages/icon-up-how-to.png": "21c2",
	"./static-pages/instagram.png": "9e1a",
	"./static-pages/oasis-park/Desktop-1.jpg": "baa8",
	"./static-pages/oasis-park/Desktop-2.jpg": "d678",
	"./static-pages/oasis-park/Desktop-3.jpg": "fcdb",
	"./static-pages/oasis-park/Mobile_Home_11.png": "2c00",
	"./static-pages/oasis-park/Mobile_Home_22.png": "6fd5",
	"./static-pages/oasis-park/Mobile_Home_33.png": "2bee",
	"./static-pages/oasis-park/Subtraction.png": "c4b7",
	"./static-pages/oasis-park/cosmos.jpg": "f6b3",
	"./static-pages/oasis-park/cross.png": "ef36",
	"./static-pages/oasis-park/footerlogo.png": "161b",
	"./static-pages/oasis-park/logo.png": "9afb",
	"./static-pages/oasis-park/mars-mission.jpg": "d76e",
	"./static-pages/oasis-park/rocket.jpg": "61a9",
	"./static-pages/past-draws-winners.png": "76c7",
	"./static-pages/point-yellow.png": "4972",
	"./static-pages/tiktok.png": "8ea8",
	"./static-pages/twitter.png": "c0a9",
	"./static-pages/youtube.png": "11536",
	"./subtract.png": "1186",
	"./tickets/Rainbow-mobile.png": "a9ab",
	"./tickets/Rainbow.png": "8bcd",
	"./tickets/background-favourite.png": "f990",
	"./tickets/background-modal.png": "6917",
	"./tickets/background.png": "29fd",
	"./tickets/bgr-checkout.png": "0162",
	"./tickets/bgr-tickets.png": "c397",
	"./tickets/desktop/arrow.png": "5a84",
	"./tickets/desktop/bg-header.png": "207e",
	"./tickets/desktop/header-entry.png": "393e",
	"./tickets/desktop/minus.png": "3aca",
	"./tickets/desktop/plus.png": "0ae6",
	"./tickets/desktop/quickpick.png": "9de5",
	"./tickets/error.png": "774a",
	"./tickets/header-mobile.png": "635b",
	"./tickets/header.png": "2a6f",
	"./tickets/line.png": "3006",
	"./tickets/minus.png": "24e5",
	"./tickets/mobile-screen-mb.png": "e193",
	"./tickets/mobile-screen.png": "4408",
	"./tickets/phone-mb.png": "5eb5",
	"./tickets/plus.png": "cd32",
	"./tickets/remove.png": "0028",
	"./tickets/shuffle.png": "2c49",
	"./toast/bg.png": "69fe",
	"./toast/error.png": "0a25",
	"./toast/success.png": "f762",
	"./toast/warning.png": "acbd",
	"./vector.png": "e3fb",
	"./wallet/arrow-right-white.png": "7583",
	"./wallet/background-phone.png": "c351",
	"./wallet/background.png": "69ba",
	"./wallet/bg-desktop.png": "b8d0",
	"./wallet/card-visa.png": "64dd",
	"./wallet/vector-right.png": "04f5",
	"./wallet/vector.png": "de1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";